// Views
import UsergroupsLayout from '../../Views/Hr/Usergroups/Layout';
import UsergroupsIndex from '../../Views/Hr/Usergroups/Index';
import UsergroupsShow from '../../Views/Hr/Usergroups/Show';
import UsergroupsForm from '../../Views/Hr/Usergroups/Form';

export default [
    {
        path:'/hr/usergroups',
        component:UsergroupsLayout,
        children: [
            {
                path:'',
                component:UsergroupsIndex,
                name:'hr.usergroups.index',
            },
            {
                path:'add',
                component:UsergroupsForm,
                name:'hr.usergroups.add',
            },
            {
                path:':uuid',
                component:UsergroupsShow,
                name:'hr.usergroups.show',
            },
            {
                path:':uuid/edit',
                component:UsergroupsForm,
                name:'hr.usergroups.edit',
            },
        ],
    },
];
